import { useState, useEffect } from "react";
import BaseInput from "../BaseInput";

const IntegerInput = ({ value, onInput, label, placeholder, max = 10, variant = 'light', ...props }) => {
    const [localValue, setLocalValue] = useState(value || "");

    useEffect(() => {
        setLocalValue(value || "");
    }, [value]);

    const handleChange = (newValue) => {
        // Ensure it's a string to prevent "replace is not a function" error if value is a number
        const stringValue = String(newValue || "");

        // Remove all non-digits and limit to max length
        const digits = stringValue.replace(/\D/g, "").slice(0, max);

        setLocalValue(digits);

        if (digits !== "") {
            onInput(parseInt(digits, 10));
        } else {
            onInput("");
        }
    };

    return (
        <BaseInput
            {...props}
            value={localValue}
            onInput={handleChange}
            label={label}
            placeholder={placeholder}
            variant={variant}
            maxLength={max}
        />
    );
};

export default IntegerInput;
